const LocationBigSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" fill="none">
            <path fill="#B6BFE7" d="M6 0a6.007 6.007 0 0 0-6 6c0 2.441 1.772 4.469 3.65 6.614.594.68 1.209 1.383 1.756 2.094a.75.75 0 0 0 1.188 0c.547-.711 1.162-1.414 1.756-2.094C10.229 10.468 12 8.441 12 6a6.007 6.007 0 0 0-6-6Zm0 8.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z"/>
        </svg>
    )
}

export default LocationBigSvg;